import { render, staticRenderFns } from "./ListadoTiposDocumentosPersona.vue?vue&type=template&id=01286c68"
import script from "./ListadoTiposDocumentosPersona.vue?vue&type=script&lang=js"
export * from "./ListadoTiposDocumentosPersona.vue?vue&type=script&lang=js"
import style0 from "./ListadoTiposDocumentosPersona.vue?vue&type=style&index=0&id=01286c68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports